import { Injectable } from "@angular/core";
import { ErrorMessageService } from "app/core/error-message.service";
import { ApiService } from "app/shared/security/api-services/api.service";
import { environment } from "environments/environment";
import { tap } from "rxjs";
import {
  IAllowableActivityDTO,
  IAllowableResponsibleDTO,
} from "../../models/currentUser";
import { CurrentUserApi } from "./current-user-api.models";

@Injectable()
export class CurrentUserApiService extends CurrentUserApi {
  private _endpointPath: string = environment.apiHost + "/v1/current-user";

  constructor(
    private apiService: ApiService,
    private errorMessageService: ErrorMessageService,
  ) {
    super();
  }

  public getAllowableResponsibles() {
    const endPoint = `${this._endpointPath}/allowable-responsibles`;
    return this.apiService.get<IAllowableResponsibleDTO[]>(endPoint).pipe(
      tap(
        (res) => res,
        (error) => {
          if (error.status !== 403) {
            this.errorMessageService.notifyError(error);
          }
        },
      ),
    );
  }

  public getAllowableActivities() {
    const endPoint = `${this._endpointPath}/allowable-activities`;
    return this.apiService.get<IAllowableActivityDTO[]>(endPoint).pipe(
      tap(
        (res) => res,
        (error) => {
          if (error.status !== 403) {
            this.errorMessageService.notifyError(error);
          }
        },
      ),
    );
  }
}
